var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 79,
    viewBox: "0 0 57 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2705 3C14.3191 3 3 13.7733 3 27.0421C3 42.3096 19.847 66.5044 26.033 74.8612C26.2898 75.214 26.6263 75.501 27.0152 75.6989C27.404 75.8968 27.8342 76 28.2705 76C28.7068 76 29.1369 75.8968 29.5258 75.6989C29.9147 75.501 30.2512 75.214 30.508 74.8612C36.694 66.5079 53.541 42.3219 53.541 27.0421C53.541 13.7733 42.2219 3 28.2705 3Z",
    stroke: "#FAFAFA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2704 36.694C32.9226 36.694 36.6939 32.9227 36.6939 28.2705C36.6939 23.6184 32.9226 19.847 28.2704 19.847C23.6183 19.847 19.8469 23.6184 19.8469 28.2705C19.8469 32.9227 23.6183 36.694 28.2704 36.694Z",
    stroke: "#FAFAFA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d027ba98806bd3dc907cb55ff2666a3c.svg";
export { ForwardRef as ReactComponent };